import { LOG_VERBOSE } from "../calc/calcService";
import ConsoleLogger from "./ConsoleLogger";
import EmptyLogger from "./EmptyLogger";
import { ILogger } from "./ILogger";

export default function createLogger(clientOnly?: boolean): ILogger {
  const isClient = typeof window !== "undefined";
  return LOG_VERBOSE && !(isClient && clientOnly) ? new ConsoleLogger() : new EmptyLogger();
}
